// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app-details-header {
  /* width: 1616px; */
  height: 43px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.header-left {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.title-row {
  display: flex;
  align-items: center;
  gap: 4px;
}

.page-title {
  margin: 0;
  font-size: 16px;
  line-height: 100%;
  font-weight: 600;
  color: #0066cc;
}

.page-subtitle {
  font-size: 14px;
  line-height: 100%;
  color: #838fb4;
}

.header-right {
  display: flex;
  align-items: center;
  gap: 8px;
}

.onboard-app-btn {
  min-width: 128px;
  height: 35px;
  padding: 8px;
  background: #0066cc;
  color: #ffffff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  box-shadow:
    0px 0px 0px 0.5px #0066cc1f,
    0px 1px 2.5px 0px #0066cc3d;
  transition: background 0.2s ease;
}

.onboard-app-btn:hover {
  background: #005bb5;
}

.onboard-app-btn .btn-text {
  font-size: 14px;
  font-weight: 400;
  letter-spacing: 0.2px;
  line-height: 1;
  transform: translateY(-0.5px);
}

.app-toolbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 22px;
  padding-left: 16px;
  gap: 16px;
}

.tabs {
  display: flex;
  align-items: flex-end;
  gap: 16px;
}

.tab {
  background: transparent;
  border: 0;
  padding: 8px 0 6px;
  cursor: pointer;
  display: inline-flex;
  align-items: baseline;
  gap: 6px;
  color: #838fb4;
  font-size: 16px;
  font-weight: 500;
  letter-spacing: 0.2px;
  line-height: 1;
  border-bottom: 2px solid transparent;
  transition:
    color 0.15s ease,
    border-color 0.15s ease;
  position: relative;
}

.tab:hover {
  color: #0066cc;
}

.tab.active {
  color: #0066cc;
  font-weight: 600;
}

.tab.active::after {
  content: '';
  position: absolute;
  bottom: -8px;
  left: 0;
  width: 100%;
  border-bottom: 2px solid #0066cc;
}

.tab-label {
  line-height: 1;
}

.tab-count {
  font-size: 14px;
  color: #838fb4;
  font-weight: 400;
  line-height: 1;
  transform: translateY(-0.5px);
}

.toolbar-right {
  display: flex;
  align-items: center;
  gap: 8px;
}

.search-box {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 224px;
  height: 35px;
  padding: 8px 24px 8px 12px;
  background: #ebf2fe;
  backdrop-filter: blur(19px);
  border: none;
  border-radius: 8px;
}

.search-box input {
  border: none;
  outline: none;
  background: transparent;
  font-size: 14px;
  color: #00000080;
  width: 100%;
}

.search-box input::placeholder {
  color: #838fb4;
}

.filter-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 78px;
  height: 35px;
  padding: 8px 10px;
  background: #ffffff;
  border: 1px solid #00000080;
  border-radius: 8px;
  backdrop-filter: blur(19px);
  font-size: 14px;
  font-weight: 400;
  color: #111111;
  cursor: pointer;
  transition: background 0.2s ease;
}

.filter-btn:hover {
  background: #f5f5f5;
}

.apps-table-container {
  /* width: 1616px; */
  position: relative;
  width: 100%;
  /* max-width: 100%; */
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  height: auto;
  max-height: 745px;
  overflow-x: auto;
  /* overflow-y: hidden; */
  overflow-y: auto;
}

.apps-table-header {
  flex: 0 0 50px;
  height: 50px;
  width: 100%;
  /* max-width: 1616px; */
  background: #ebf2fe;
  border-radius: 4px;
  margin-top: 20px;
  /* overflow: hidden; */
  /* min-width: 950px; */
  overflow-x: auto;
}

.apps-table-header .apps-table-row {
  height: 100%;
  align-items: center;
  padding-left: 10px;
}

/* .apps-table-row{
  display: grid;
  grid-template-columns: 64px 128px 351px 351px 156px 120px 128px 160px 136px;
  width: 100%;
}

.body-row {
  display: grid;
  grid-template-columns: 64px 128px 351px 351px 156px 120px 128px 160px 136px;
  width: 100%;
  padding: 4px 0;
  background: #fff;
  align-items: stretch;
} */

.apps-table-row,
.body-row {
  display: grid;
  grid-template-columns: 1.2fr 2fr 2fr 1fr 1fr 1.2fr 1.4fr 1.2fr; /* proportional widths */
  width: 100%;
  min-width: 950px;
  align-items: center;
  /* padding: 4px 0;
  background: #fff; */
}

.body-row {
  padding: 12px 0px;
}
/* Only for Manage App Requests table */
/* .apps-table-row.request-columns,
.body-row.request-columns {
  display: grid;
  grid-template-columns: 
    64px 150px 228px 228px 156px 120px 142px 232px 160px 136px;
} */

.apps-table-row.request-columns,
.body-row.request-columns {
  display: grid;
  grid-template-columns: 1.2fr 2fr 2fr 1.2fr 1fr 1.3fr 1.4fr 1.4fr 1.2fr;
  /* grid-template-columns: 
    60px 1.2fr 2fr 2fr 1.2fr 1fr 1.2fr 2fr 1.4fr 1.2fr; */
  width: 100%;
  min-width: 950px;
  align-items: center;
}

.sort-icon.asc {
  transform: rotate(180deg);
  transition: transform 0.2s;
}

.sort-icon.desc {
  transform: rotate(0deg);
  transition: transform 0.2s;
}

/* .apps-col {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 12px 8px;
  font-size: 14px;
  font-weight: 400;
  color: #303030;
  line-height: 1.4;
  word-break: break-word;
  cursor: pointer;
  user-select: none;
} */

.apps-col {
  /* padding: 12px 8px; */
  font-size: 14px;
  word-break: break-word;
  justify-content: flex-start;
}

/* .apps-col-header{
  padding: 12px 8px;
  font-size: 12px;
  word-break: break-word;
  font-weight: 600;
} */

.apps-col.id {
  justify-content: flex-start;
}

.sort-icon {
  stroke-width: 1;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transform: translateY(1px);
  color: #111;
}

/* .apps-table-body {
  flex: 0 1 auto;
  overflow-y: auto;
  overflow-x: auto;
  width: 100%;
  max-width: 1616px;
  border-radius: 4px;
  scrollbar-width: none;
  -ms-overflow-style: none;
} */

.apps-table-body {
  flex: 1 1;
  overflow-y: auto;
  overflow-x: auto;
  width: 100%;
  border-radius: 4px;
  max-height: calc(100vh - 309px);
  padding-left: 10px;
  /* scrollbar-width: thin;
  scrollbar-color: #ccc transparent; */
}

.apps-table-body::-webkit-scrollbar {
  display: none;
  /* height: 8px; */
}

.apps-table-body .body-row:not(:last-child) {
  border-bottom: 1px solid #bfd7fb;
}

.body-row:hover {
  background: #f9fbff;
}

.apps-col.models {
  display: flex;
  gap: 6px;
  align-items: flex-start;
}

.more-models {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 22px;
  padding: 10px;
  background: #ebf2fe;
  color: #0066cc;
  font-size: 12px;
  font-weight: 600;
  border-radius: 4px;
  opacity: 1;
  margin-left: 5px;
}

.apps-col.actions {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  /* gap: 15px; */
}

.action-btn {
  background: transparent;
  border: none;
  cursor: pointer;
  color: #111;
}

.action-btn:hover {
  color: #004a99;
}

.apps-table-footer {
  /* flex: 0 0 auto; */
  position: sticky;
  bottom: 0;
  z-index: 10;
  width: 100%;
  height: 50px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 16px;
  border-radius: 4px;
  border: 1px solid #f0f6ff;
  background: #ebf2fe;
  font-size: 14px;
  font-weight: 400;
  color: #71717a;
}

.footer-count {
  color: #111111;
}

.footer-center {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 15px;
  width: 204px;
  height: 36px;
}

.page-info {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 25px;
  width: 120px;
  height: 36px;
  font-size: 14px;
  color: #303030;
}

.page-number,
.of-text {
  font-size: 14px;
  position: relative;
  color: #71717a;
}

.page-number.active {
  font-weight: 400;
  color: #0066cc;
}

.page-number.active::after {
  content: '';
  position: absolute;
  bottom: -9px;
  left: -10px;
  right: -10px;
  height: 2px;
  background-color: #0066cc;
  border-radius: 1px;
}

.page-btn {
  background: transparent;
  border: none;
  cursor: pointer;
  color: #0066cc;
  display: flex;
  align-items: center;
  justify-content: center;
}
.page-btn:disabled {
  opacity: 0.3;
  cursor: not-allowed;
}

.page-info .of-text {
  color: #838fb4;
  margin: 0 4px;
}

.footer-right {
  display: flex;
  align-items: center;
  gap: 2px;
}

.footer-right select {
  border: none;
  border-radius: 4px;
  font-size: 15px;
  background-color: #f0f6ff;
  color: #111111;
  outline: none;
}

/* ===== Tier Badges ===== */
.tier-badge {
  display: inline-block;
  padding: 4px 10px;
  border-radius: 12px;
  font-size: 13px;
  font-weight: 500;
  text-transform: capitalize;
  line-height: 1;
}

/* Fixed colors for known tiers */

.tier-badge.standard {
  background: #0066cc26;
  border: 1px solid #0066cc80;
  color: #0066cc;
}

.tier-badge.standard-extended-support {
  background: #1f36c726;
  border: 1px solid #1f36c780;
  color: #1f36c7;
  width: 85px;
}

.tier-badge.premium {
  background: #7705bc26;
  border: 1px solid #7705bc80;
  color: #7705bc;
}

/* Extra color palette for future tiers */
.tier-badge.extra1 {
  background: #00808026;
  border: 1px solid #00808080;
  color: #008080;
}

.tier-badge.extra2 {
  background: #d9770626;
  border: 1px solid #d9770680;
  color: #d97706;
}

.tier-badge.extra3 {
  background: #2563eb26;
  border: 1px solid #2563eb80;
  color: #2563eb;
}

/* ===== Status Badges ===== */
.status-badge {
  display: inline-block;
  padding: 4px 10px;
  border-radius: 12px;
  font-size: 13px;
  font-weight: 500;
  line-height: 1;
  text-transform: capitalize;
}

.status-badge.approved {
  background: #00865126;
  border: 1px solid #00865180;
  color: #008651;
}

.status-badge.approved-processing {
  background: #00865126;
  border: 1px solid #00865180;
  color: #008651;
  width: 90px;
}

.status-badge.pending {
  background: #ff9e0026;
  border: 1px solid #ff9e0080;
  color: #ff9e00;
}

.status-badge.rejected {
  background: #ff282826;
  border: 1px solid #ff282880;
  color: #ff2828;
}

/* 🔥 Highlight rows that have errors even though Approved-processing */
.row-error-highlight {
  background-color: rgba(255, 40, 40, 0.06); /* subtle red tint */
}
.tooltip.show {
  opacity: 1 !important;
}

.tooltip-inner {
  background-color: #333 !important;
  color: #fff !important;
  font-size: 13px;
  max-width: 250px;
  text-align: left;
  padding: 8px 10px;
  border-radius: 6px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
  white-space: normal !important;
  word-break: break-word;
}
.tooltip.bs-tooltip-top {
  transform: translateX(-100px); /* move slightly left to create right spacing */
}

.tooltip.bs-tooltip-top .tooltip-arrow::before {
  border-top-color: #333 !important;
}

/* ===== Modal Overlay ===== */
/* Overlay dim background */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.4); /* dimmed background */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999; /* make sure it's above everything */
}

/* White modal box */
.modal-box {
  background: #fff;
  width: 480px;
  border-radius: 8px;
  padding: 16px;
  box-shadow: 0px 8px 20px rgba(0, 0, 0, 0.2);
  animation: fadeIn 0.2s ease-in-out;
}

/* Header row */
.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}

.modal-header h3 {
  font-size: 16px;
  font-weight: 600;
  margin: 0;
}

.modal-close {
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px;
}

/* Comment box body */
.modal-body {
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  padding: 12px;
  font-size: 14px;
  color: #333;
  min-height: 80px;
  background: #fafafa;
}
/* Comment Icon Button */
.comment-icon-btn {
  background: transparent;
  border: none;
  margin-left: 6px;
  cursor: pointer;
  color: #ff2828;
  display: inline-flex;
  align-items: center;
}

.comment-icon-btn:hover {
  opacity: 0.8;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* ===== Filter Popup ===== */
.filter-container {
  position: relative;
  display: inline-block;
}

.filter-popup {
  position: absolute;
  top: 100%;
  right: 0;
  margin-top: 8px;
  width: 654px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.15);
  z-index: 1000;
  padding: 20px;
  overflow-y: auto;
  font-family: 'Inter', sans-serif;
}

.filter-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 12px; /* add some spacing above line */
  border-bottom: 1px solid #e0e0e0; /* separator line */
  color: #0066cc;
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 20px; /* optional, keep spacing for content below */
}

.close-btn {
  border: none;
  background: transparent;
  font-size: 18px;
  cursor: pointer;
}

/* Sections */
.filter-section {
  margin-bottom: 20px;
  position: relative;
}

.filter-section label {
  font-size: 14px;
  font-weight: 400;
  display: block;
  margin-bottom: 6px;
  color: #111;
}

.reset-link {
  position: absolute;
  top: 0;
  right: 0;
  border: none;
  background: none;
  color: #007bff;
  font-size: 13px;
  cursor: pointer;
}

.date-range {
  display: flex;
  align-items: center;
  gap: 10px;
}

.date-range input,
.filter-section select {
  width: 100%;
  padding: 10px;
  background: #fff;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  font-size: 14px;
  color: #0066cc;
}

.date-range span {
  font-size: 13px;
  color: #666;
}

.filter-footer {
  display: flex;
  justify-content: space-between;
  padding-top: 12px; /* add some spacing below line */
  border-top: 1px solid #e0e0e0; /* separator line */
  margin-top: 30px; /* keep spacing from content above */
}

.reset-all {
  background: #fff;
  border: 1px solid #e0e0e0;
  padding: 8px;
  gap: 4px;
  border-radius: 4px;
  cursor: pointer;
  color: #0066cc;
  font-size: 14;
}

.apply-btn {
  background: #0066cc;
  color: #fff;
  border: none;
  width: 57px;
  height: 35px;
  padding: 8px;
  gap: 4px;
  border-radius: 4px;
  cursor: pointer;
}

.side-modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.4);
  display: flex;
  justify-content: flex-end;
  z-index: 1000;
}

.side-modal {
  background: #fff;
  width: 640px;
  /* height: 849px; */
  padding: 30px;
  box-shadow: -2px 0 8px rgba(0, 0, 0, 0.1);
  overflow-y: auto;
  border-radius: 8px 0 0 8px;
  margin-top: 80px;
  display: flex;
  flex-direction: column;
  margin-right: 8px;
}

.side-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #e6e6e6;
  padding-bottom: 12px;
  margin-bottom: 10px;
}

.app-title {
  font-size: 18px;
  font-weight: 600;
  color: #0066cc;
  margin: 0;
}

.app-subtitle {
  font-size: 14px;
  color: #999;
  margin: 0;
}

.modal-close {
  background: none;
  border: none;
  cursor: pointer;
}

.info-row {
  display: grid;
  grid-template-columns: 150px 1fr; /* first column fixed width for labels, second column fills remaining space */
  column-gap: 40px; /* horizontal gap between label and value */
  margin: 16px 0;
  font-size: 14px;
}

.info-row .label {
  color: #5b5b5b;
  font-weight: 400;
  justify-self: start;
  width: 184px;
}
.info-row span:nth-child(2) {
  justify-self: start;
}

.tier-pill {
  padding: 4px 10px;
  background: #f4f4f4;
  border-radius: 16px;
  font-size: 12px;
}

.description-box {
  background: #f2f7fe;
  padding: 12px;
  border-radius: 6px;
  margin: 20px 0;
}

.description-box h4 {
  margin: 0 0 6px;
  font-size: 14px;
  color: #5b5b5b;
  font-weight: 400;
}

.section-title {
  font-size: 15px;
  font-weight: 500;
  margin: 20px 0 10px;
  border-bottom: 1px solid #ccc;
  padding-bottom: 4px;
}

.action-modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.3);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
}

.action-modal {
  width: 580px;
  border: 1px solid #ddd;
  border-radius: 8px;
  background: #fff;
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  text-align: center;
}

.action-modal-title {
  font-size: 16px;
  margin: 0;
}

.action-modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  border-top: 1px solid #0047b3;
  padding-top: 16px;
}

.btn-cancel {
  background: transparent;
  border: none;
  padding: 6px 16px;
  border-radius: 4px;
  cursor: pointer;
  color: #2563eb;
  box-shadow: 0px 0.5px 2.5px 0px #0000004d;
}

.btn-confirm {
  background: transparent;
  border: none;
  padding: 6px 16px;
  border-radius: 4px;
  cursor: pointer;
  box-shadow: 0px 0.5px 2.5px 0px #0000004d;
}

.btn-confirm.accept {
  color: #10b981;
}

.btn-confirm.reject {
  color: #ef4444;
}

.action-modal-icon {
  width: 87px;
  height: 88px;
  margin: 0 auto;
}

.action-modal-title.accept {
  color: #10b981; /* green */
}

.action-modal-title.reject {
  color: #ef4444; /* red */
}

.action-modal-comment {
  width: 100%;
  min-height: 80px;
  border: 1px solid #ddd; /* default border */
  border-radius: 6px;
  padding: 8px;
  resize: none;
  outline: none; /* remove default browser outline */
  transition: border-color 0.2s; /* smooth transition */
  color: #808080;
}

/* Change border color on focus */
.action-modal-comment:focus {
  border-color: #2563eb; /* blue border on focus */
  box-shadow: 0 0 0 2px rgba(37, 99, 235, 0.2); /* optional subtle glow */
}

/* ===== Responsive Breakpoints ===== */

/* Medium devices (tablets) */
@media (max-width: 1280px) {
  .apps-col {
    font-size: 10px;
  }
}

@media (max-width: 992px) {
  .apps-table-container {
    overflow-x: auto;
  }
  .apps-table-row,
  .body-row {
    grid-template-columns: 50px 1fr 1.5fr 1.5fr 1fr 1fr 1fr 1fr; /* fewer columns visible */
  }
  /* .apps-col:nth-child(9) { display: none; } hide less-important last col */
  .apps-table-header {
    overflow-x: auto;
    font-size: 0.6875rem;
    font-weight: bold;
  }
}

/* Small devices (mobile) */
@media (max-width: 768px) {
  .apps-table-header,
  .apps-table-body {
    min-width: 650px; /* make table scroll horizontally */
  }

  .apps-table-row,
  .body-row {
    grid-template-columns: 50px 1.2fr 1.8fr 1.8fr 1fr; /* show first few key columns */
  }

  /* Hide secondary columns on mobile */
  .apps-col:nth-child(n + 6) {
    display: none;
  }

  /* Adjust search/filter bar */
  .app-toolbar {
    flex-direction: column;
    align-items: flex-start;
  }

  .toolbar-right {
    width: 100%;
    justify-content: space-between;
  }

  .search-box {
    width: 100%;
  }
}

/* Extra small devices */
@media (max-width: 480px) {
  .page-title {
    font-size: 14px;
  }

  .onboard-app-btn {
    min-width: 100px;
    font-size: 12px;
  }

  .apps-col {
    font-size: 13px;
    padding: 10px 6px;
  }

  .apps-col_tier {
    font-size: 12px;
    padding: 10px 6px;
  }
}

@media (max-width: 1536px) {
  .filter-popup {
    width: 540px;
    padding: 10px;
  }
  .filter-header {
    font-size: 15px;
    padding-bottom: 5px;
    margin-bottom: 10px;
  }
  .filter-footer {
    padding-top: 0px;
    border-top: 0px;
    margin-top: 0px;
  }
  .filter-section {
    margin-bottom: 10px;
  }
}

.apps-table-header::-webkit-scrollbar {
  width: 1px;
  height: 3px;
}

.apps-table-header::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.2);
  border-radius: 3px;
}
`, "",{"version":3,"sources":["webpack://./src/components/AppDetails.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR;;+BAE6B;EAC7B,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,cAAc;EACd,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,SAAS;AACX;;AAEA;EACE,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,qBAAqB;EACrB,QAAQ;EACR,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,cAAc;EACd,oCAAoC;EACpC;;2BAEyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,OAAO;EACP,WAAW;EACX,gCAAgC;AAClC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,YAAY;EACZ,0BAA0B;EAC1B,mBAAmB;EACnB,2BAA2B;EAC3B,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,2BAA2B;EAC3B,kBAAkB;EAClB,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,qBAAqB;EACrB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,WAAW;EACX,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;;;;;;;;;;;;;GAaG;;AAEH;;EAEE,aAAa;EACb,8DAA8D,EAAE,wBAAwB;EACxF,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB;qBACmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;AACA,uCAAuC;AACvC;;;;;GAKG;;AAEH;;EAEE,aAAa;EACb,sEAAsE;EACtE;yDACuD;EACvD,WAAW;EACX,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,uBAAuB;EACvB,0BAA0B;AAC5B;;AAEA;;;;;;;;;;;;GAYG;;AAEH;EACE,uBAAuB;EACvB,eAAe;EACf,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;;;;;GAKG;;AAEH;EACE,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,0BAA0B;EAC1B,WAAW;AACb;;AAEA;;;;;;;;;GASG;;AAEH;EACE,SAAO;EACP,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,+BAA+B;EAC/B,kBAAkB;EAClB;sCACoC;AACtC;;AAEA;EACE,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;EACZ,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,cAAc;AAChB;;AAEA;;EAEE,eAAe;EACf,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,WAAW;EACX,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,cAAc;EACd,aAAa;AACf;;AAEA,4BAA4B;AAC5B;EACE,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,cAAc;AAChB;;AAEA,iCAAiC;;AAEjC;EACE,qBAAqB;EACrB,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,2BAA2B;EAC3B,cAAc;EACd,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,2BAA2B;EAC3B,cAAc;AAChB;;AAEA,yCAAyC;AACzC;EACE,qBAAqB;EACrB,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,2BAA2B;EAC3B,cAAc;AAChB;;AAEA,8BAA8B;AAC9B;EACE,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;EACrB,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,2BAA2B;EAC3B,cAAc;EACd,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,2BAA2B;EAC3B,cAAc;AAChB;;AAEA,uEAAuE;AACvE;EACE,yCAAyC,EAAE,oBAAoB;AACjE;AACA;EACE,qBAAqB;AACvB;;AAEA;EACE,iCAAiC;EACjC,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,wCAAwC;EACxC,8BAA8B;EAC9B,sBAAsB;AACxB;AACA;EACE,6BAA6B,EAAE,+CAA+C;AAChF;;AAEA;EACE,iCAAiC;AACnC;;AAEA,8BAA8B;AAC9B,2BAA2B;AAC3B;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,YAAY;EACZ,aAAa;EACb,8BAA8B,EAAE,sBAAsB;EACtD,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY,EAAE,oCAAoC;AACpD;;AAEA,oBAAoB;AACpB;EACE,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,2CAA2C;EAC3C,kCAAkC;AACpC;;AAEA,eAAe;AACf;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,YAAY;AACd;;AAEA,qBAAqB;AACrB;EACE,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,mBAAmB;AACrB;AACA,wBAAwB;AACxB;EACE,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,6BAA6B;AAC7B;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,4CAA4C;EAC5C,aAAa;EACb,aAAa;EACb,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,oBAAoB,EAAE,gCAAgC;EACtD,gCAAgC,EAAE,mBAAmB;EACrD,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB,EAAE,6CAA6C;AACpE;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,eAAe;AACjB;;AAEA,aAAa;AACb;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;;EAEE,WAAW;EACX,aAAa;EACb,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,iBAAiB,EAAE,gCAAgC;EACnD,6BAA6B,EAAE,mBAAmB;EAClD,gBAAgB,EAAE,oCAAoC;AACxD;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,YAAY;EACZ,QAAQ;EACR,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,QAAQ;EACR,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,8BAA8B;EAC9B,aAAa;EACb,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,yCAAyC;EACzC,gBAAgB;EAChB,0BAA0B;EAC1B,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gCAAgC;EAChC,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,eAAe;EACf,WAAW;EACX,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,gCAAgC,EAAE,6EAA6E;EAC/G,gBAAgB,EAAE,2CAA2C;EAC7D,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,YAAY;EACZ,aAAa;EACb,8BAA8B;EAC9B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,SAAS;AACX;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,6BAA6B;EAC7B,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,yCAAyC;AAC3C;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,yCAAyC;AAC3C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,cAAc,EAAE,UAAU;AAC5B;;AAEA;EACE,cAAc,EAAE,QAAQ;AAC1B;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,sBAAsB,EAAE,mBAAmB;EAC3C,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,aAAa,EAAE,mCAAmC;EAClD,6BAA6B,EAAE,sBAAsB;EACrD,cAAc;AAChB;;AAEA,iCAAiC;AACjC;EACE,qBAAqB,EAAE,yBAAyB;EAChD,4CAA4C,EAAE,yBAAyB;AACzE;;AAEA,uCAAuC;;AAEvC,6BAA6B;AAC7B;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;EACA;;IAEE,2DAA2D,EAAE,0BAA0B;EACzF;EACA,2EAA2E;EAC3E;IACE,gBAAgB;IAChB,oBAAoB;IACpB,iBAAiB;EACnB;AACF;;AAEA,2BAA2B;AAC3B;EACE;;IAEE,gBAAgB,EAAE,mCAAmC;EACvD;;EAEA;;IAEE,iDAAiD,EAAE,+BAA+B;EACpF;;EAEA,qCAAqC;EACrC;IACE,aAAa;EACf;;EAEA,6BAA6B;EAC7B;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,WAAW;IACX,8BAA8B;EAChC;;EAEA;IACE,WAAW;EACb;AACF;;AAEA,wBAAwB;AACxB;EACE;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,YAAY;IACZ,aAAa;EACf;EACA;IACE,eAAe;IACf,mBAAmB;IACnB,mBAAmB;EACrB;EACA;IACE,gBAAgB;IAChB,eAAe;IACf,eAAe;EACjB;EACA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;AACpB","sourcesContent":[".app-details-header {\n  /* width: 1616px; */\n  height: 43px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.header-left {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.title-row {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.page-title {\n  margin: 0;\n  font-size: 16px;\n  line-height: 100%;\n  font-weight: 600;\n  color: #0066cc;\n}\n\n.page-subtitle {\n  font-size: 14px;\n  line-height: 100%;\n  color: #838fb4;\n}\n\n.header-right {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.onboard-app-btn {\n  min-width: 128px;\n  height: 35px;\n  padding: 8px;\n  background: #0066cc;\n  color: #ffffff;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  box-shadow:\n    0px 0px 0px 0.5px #0066cc1f,\n    0px 1px 2.5px 0px #0066cc3d;\n  transition: background 0.2s ease;\n}\n\n.onboard-app-btn:hover {\n  background: #005bb5;\n}\n\n.onboard-app-btn .btn-text {\n  font-size: 14px;\n  font-weight: 400;\n  letter-spacing: 0.2px;\n  line-height: 1;\n  transform: translateY(-0.5px);\n}\n\n.app-toolbar {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-top: 22px;\n  padding-left: 16px;\n  gap: 16px;\n}\n\n.tabs {\n  display: flex;\n  align-items: flex-end;\n  gap: 16px;\n}\n\n.tab {\n  background: transparent;\n  border: 0;\n  padding: 8px 0 6px;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: baseline;\n  gap: 6px;\n  color: #838fb4;\n  font-size: 16px;\n  font-weight: 500;\n  letter-spacing: 0.2px;\n  line-height: 1;\n  border-bottom: 2px solid transparent;\n  transition:\n    color 0.15s ease,\n    border-color 0.15s ease;\n  position: relative;\n}\n\n.tab:hover {\n  color: #0066cc;\n}\n\n.tab.active {\n  color: #0066cc;\n  font-weight: 600;\n}\n\n.tab.active::after {\n  content: '';\n  position: absolute;\n  bottom: -8px;\n  left: 0;\n  width: 100%;\n  border-bottom: 2px solid #0066cc;\n}\n\n.tab-label {\n  line-height: 1;\n}\n\n.tab-count {\n  font-size: 14px;\n  color: #838fb4;\n  font-weight: 400;\n  line-height: 1;\n  transform: translateY(-0.5px);\n}\n\n.toolbar-right {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.search-box {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  width: 224px;\n  height: 35px;\n  padding: 8px 24px 8px 12px;\n  background: #ebf2fe;\n  backdrop-filter: blur(19px);\n  border: none;\n  border-radius: 8px;\n}\n\n.search-box input {\n  border: none;\n  outline: none;\n  background: transparent;\n  font-size: 14px;\n  color: #00000080;\n  width: 100%;\n}\n\n.search-box input::placeholder {\n  color: #838fb4;\n}\n\n.filter-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  width: 78px;\n  height: 35px;\n  padding: 8px 10px;\n  background: #ffffff;\n  border: 1px solid #00000080;\n  border-radius: 8px;\n  backdrop-filter: blur(19px);\n  font-size: 14px;\n  font-weight: 400;\n  color: #111111;\n  cursor: pointer;\n  transition: background 0.2s ease;\n}\n\n.filter-btn:hover {\n  background: #f5f5f5;\n}\n\n.apps-table-container {\n  /* width: 1616px; */\n  position: relative;\n  width: 100%;\n  /* max-width: 100%; */\n  border-radius: 4px;\n  display: flex;\n  flex-direction: column;\n  height: auto;\n  max-height: 745px;\n  overflow-x: auto;\n  /* overflow-y: hidden; */\n  overflow-y: auto;\n}\n\n.apps-table-header {\n  flex: 0 0 50px;\n  height: 50px;\n  width: 100%;\n  /* max-width: 1616px; */\n  background: #ebf2fe;\n  border-radius: 4px;\n  margin-top: 20px;\n  /* overflow: hidden; */\n  /* min-width: 950px; */\n  overflow-x: auto;\n}\n\n.apps-table-header .apps-table-row {\n  height: 100%;\n  align-items: center;\n  padding-left: 10px;\n}\n\n/* .apps-table-row{\n  display: grid;\n  grid-template-columns: 64px 128px 351px 351px 156px 120px 128px 160px 136px;\n  width: 100%;\n}\n\n.body-row {\n  display: grid;\n  grid-template-columns: 64px 128px 351px 351px 156px 120px 128px 160px 136px;\n  width: 100%;\n  padding: 4px 0;\n  background: #fff;\n  align-items: stretch;\n} */\n\n.apps-table-row,\n.body-row {\n  display: grid;\n  grid-template-columns: 1.2fr 2fr 2fr 1fr 1fr 1.2fr 1.4fr 1.2fr; /* proportional widths */\n  width: 100%;\n  min-width: 950px;\n  align-items: center;\n  /* padding: 4px 0;\n  background: #fff; */\n}\n\n.body-row {\n  padding: 12px 0px;\n}\n/* Only for Manage App Requests table */\n/* .apps-table-row.request-columns,\n.body-row.request-columns {\n  display: grid;\n  grid-template-columns: \n    64px 150px 228px 228px 156px 120px 142px 232px 160px 136px;\n} */\n\n.apps-table-row.request-columns,\n.body-row.request-columns {\n  display: grid;\n  grid-template-columns: 1.2fr 2fr 2fr 1.2fr 1fr 1.3fr 1.4fr 1.4fr 1.2fr;\n  /* grid-template-columns: \n    60px 1.2fr 2fr 2fr 1.2fr 1fr 1.2fr 2fr 1.4fr 1.2fr; */\n  width: 100%;\n  min-width: 950px;\n  align-items: center;\n}\n\n.sort-icon.asc {\n  transform: rotate(180deg);\n  transition: transform 0.2s;\n}\n\n.sort-icon.desc {\n  transform: rotate(0deg);\n  transition: transform 0.2s;\n}\n\n/* .apps-col {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  padding: 12px 8px;\n  font-size: 14px;\n  font-weight: 400;\n  color: #303030;\n  line-height: 1.4;\n  word-break: break-word;\n  cursor: pointer;\n  user-select: none;\n} */\n\n.apps-col {\n  /* padding: 12px 8px; */\n  font-size: 14px;\n  word-break: break-word;\n  justify-content: flex-start;\n}\n\n/* .apps-col-header{\n  padding: 12px 8px;\n  font-size: 12px;\n  word-break: break-word;\n  font-weight: 600;\n} */\n\n.apps-col.id {\n  justify-content: flex-start;\n}\n\n.sort-icon {\n  stroke-width: 1;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  transform: translateY(1px);\n  color: #111;\n}\n\n/* .apps-table-body {\n  flex: 0 1 auto;\n  overflow-y: auto;\n  overflow-x: auto;\n  width: 100%;\n  max-width: 1616px;\n  border-radius: 4px;\n  scrollbar-width: none;\n  -ms-overflow-style: none;\n} */\n\n.apps-table-body {\n  flex: 1;\n  overflow-y: auto;\n  overflow-x: auto;\n  width: 100%;\n  border-radius: 4px;\n  max-height: calc(100vh - 309px);\n  padding-left: 10px;\n  /* scrollbar-width: thin;\n  scrollbar-color: #ccc transparent; */\n}\n\n.apps-table-body::-webkit-scrollbar {\n  display: none;\n  /* height: 8px; */\n}\n\n.apps-table-body .body-row:not(:last-child) {\n  border-bottom: 1px solid #bfd7fb;\n}\n\n.body-row:hover {\n  background: #f9fbff;\n}\n\n.apps-col.models {\n  display: flex;\n  gap: 6px;\n  align-items: flex-start;\n}\n\n.more-models {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  height: 22px;\n  padding: 10px;\n  background: #ebf2fe;\n  color: #0066cc;\n  font-size: 12px;\n  font-weight: 600;\n  border-radius: 4px;\n  opacity: 1;\n  margin-left: 5px;\n}\n\n.apps-col.actions {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  /* gap: 15px; */\n}\n\n.action-btn {\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  color: #111;\n}\n\n.action-btn:hover {\n  color: #004a99;\n}\n\n.apps-table-footer {\n  /* flex: 0 0 auto; */\n  position: sticky;\n  bottom: 0;\n  z-index: 10;\n  width: 100%;\n  height: 50px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 8px 16px;\n  border-radius: 4px;\n  border: 1px solid #f0f6ff;\n  background: #ebf2fe;\n  font-size: 14px;\n  font-weight: 400;\n  color: #71717a;\n}\n\n.footer-count {\n  color: #111111;\n}\n\n.footer-center {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 15px;\n  width: 204px;\n  height: 36px;\n}\n\n.page-info {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 25px;\n  width: 120px;\n  height: 36px;\n  font-size: 14px;\n  color: #303030;\n}\n\n.page-number,\n.of-text {\n  font-size: 14px;\n  position: relative;\n  color: #71717a;\n}\n\n.page-number.active {\n  font-weight: 400;\n  color: #0066cc;\n}\n\n.page-number.active::after {\n  content: '';\n  position: absolute;\n  bottom: -9px;\n  left: -10px;\n  right: -10px;\n  height: 2px;\n  background-color: #0066cc;\n  border-radius: 1px;\n}\n\n.page-btn {\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  color: #0066cc;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.page-btn:disabled {\n  opacity: 0.3;\n  cursor: not-allowed;\n}\n\n.page-info .of-text {\n  color: #838fb4;\n  margin: 0 4px;\n}\n\n.footer-right {\n  display: flex;\n  align-items: center;\n  gap: 2px;\n}\n\n.footer-right select {\n  border: none;\n  border-radius: 4px;\n  font-size: 15px;\n  background-color: #f0f6ff;\n  color: #111111;\n  outline: none;\n}\n\n/* ===== Tier Badges ===== */\n.tier-badge {\n  display: inline-block;\n  padding: 4px 10px;\n  border-radius: 12px;\n  font-size: 13px;\n  font-weight: 500;\n  text-transform: capitalize;\n  line-height: 1;\n}\n\n/* Fixed colors for known tiers */\n\n.tier-badge.standard {\n  background: #0066cc26;\n  border: 1px solid #0066cc80;\n  color: #0066cc;\n}\n\n.tier-badge.standard-extended-support {\n  background: #1f36c726;\n  border: 1px solid #1f36c780;\n  color: #1f36c7;\n  width: 85px;\n}\n\n.tier-badge.premium {\n  background: #7705bc26;\n  border: 1px solid #7705bc80;\n  color: #7705bc;\n}\n\n/* Extra color palette for future tiers */\n.tier-badge.extra1 {\n  background: #00808026;\n  border: 1px solid #00808080;\n  color: #008080;\n}\n\n.tier-badge.extra2 {\n  background: #d9770626;\n  border: 1px solid #d9770680;\n  color: #d97706;\n}\n\n.tier-badge.extra3 {\n  background: #2563eb26;\n  border: 1px solid #2563eb80;\n  color: #2563eb;\n}\n\n/* ===== Status Badges ===== */\n.status-badge {\n  display: inline-block;\n  padding: 4px 10px;\n  border-radius: 12px;\n  font-size: 13px;\n  font-weight: 500;\n  line-height: 1;\n  text-transform: capitalize;\n}\n\n.status-badge.approved {\n  background: #00865126;\n  border: 1px solid #00865180;\n  color: #008651;\n}\n\n.status-badge.approved-processing {\n  background: #00865126;\n  border: 1px solid #00865180;\n  color: #008651;\n  width: 90px;\n}\n\n.status-badge.pending {\n  background: #ff9e0026;\n  border: 1px solid #ff9e0080;\n  color: #ff9e00;\n}\n\n.status-badge.rejected {\n  background: #ff282826;\n  border: 1px solid #ff282880;\n  color: #ff2828;\n}\n\n/* 🔥 Highlight rows that have errors even though Approved-processing */\n.row-error-highlight {\n  background-color: rgba(255, 40, 40, 0.06); /* subtle red tint */\n}\n.tooltip.show {\n  opacity: 1 !important;\n}\n\n.tooltip-inner {\n  background-color: #333 !important;\n  color: #fff !important;\n  font-size: 13px;\n  max-width: 250px;\n  text-align: left;\n  padding: 8px 10px;\n  border-radius: 6px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);\n  white-space: normal !important;\n  word-break: break-word;\n}\n.tooltip.bs-tooltip-top {\n  transform: translateX(-100px); /* move slightly left to create right spacing */\n}\n\n.tooltip.bs-tooltip-top .tooltip-arrow::before {\n  border-top-color: #333 !important;\n}\n\n/* ===== Modal Overlay ===== */\n/* Overlay dim background */\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100vw;\n  height: 100vh;\n  background: rgba(0, 0, 0, 0.4); /* dimmed background */\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 999; /* make sure it's above everything */\n}\n\n/* White modal box */\n.modal-box {\n  background: #fff;\n  width: 480px;\n  border-radius: 8px;\n  padding: 16px;\n  box-shadow: 0px 8px 20px rgba(0, 0, 0, 0.2);\n  animation: fadeIn 0.2s ease-in-out;\n}\n\n/* Header row */\n.modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 12px;\n}\n\n.modal-header h3 {\n  font-size: 16px;\n  font-weight: 600;\n  margin: 0;\n}\n\n.modal-close {\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 4px;\n}\n\n/* Comment box body */\n.modal-body {\n  border: 1px solid #e0e0e0;\n  border-radius: 6px;\n  padding: 12px;\n  font-size: 14px;\n  color: #333;\n  min-height: 80px;\n  background: #fafafa;\n}\n/* Comment Icon Button */\n.comment-icon-btn {\n  background: transparent;\n  border: none;\n  margin-left: 6px;\n  cursor: pointer;\n  color: #ff2828;\n  display: inline-flex;\n  align-items: center;\n}\n\n.comment-icon-btn:hover {\n  opacity: 0.8;\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(-10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* ===== Filter Popup ===== */\n.filter-container {\n  position: relative;\n  display: inline-block;\n}\n\n.filter-popup {\n  position: absolute;\n  top: 100%;\n  right: 0;\n  margin-top: 8px;\n  width: 654px;\n  background: #fff;\n  border-radius: 8px;\n  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.15);\n  z-index: 1000;\n  padding: 20px;\n  overflow-y: auto;\n  font-family: 'Inter', sans-serif;\n}\n\n.filter-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding-bottom: 12px; /* add some spacing above line */\n  border-bottom: 1px solid #e0e0e0; /* separator line */\n  color: #0066cc;\n  font-size: 16px;\n  font-weight: 600;\n  margin-bottom: 20px; /* optional, keep spacing for content below */\n}\n\n.close-btn {\n  border: none;\n  background: transparent;\n  font-size: 18px;\n  cursor: pointer;\n}\n\n/* Sections */\n.filter-section {\n  margin-bottom: 20px;\n  position: relative;\n}\n\n.filter-section label {\n  font-size: 14px;\n  font-weight: 400;\n  display: block;\n  margin-bottom: 6px;\n  color: #111;\n}\n\n.reset-link {\n  position: absolute;\n  top: 0;\n  right: 0;\n  border: none;\n  background: none;\n  color: #007bff;\n  font-size: 13px;\n  cursor: pointer;\n}\n\n.date-range {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.date-range input,\n.filter-section select {\n  width: 100%;\n  padding: 10px;\n  background: #fff;\n  border: 1px solid #e0e0e0;\n  border-radius: 4px;\n  font-size: 14px;\n  color: #0066cc;\n}\n\n.date-range span {\n  font-size: 13px;\n  color: #666;\n}\n\n.filter-footer {\n  display: flex;\n  justify-content: space-between;\n  padding-top: 12px; /* add some spacing below line */\n  border-top: 1px solid #e0e0e0; /* separator line */\n  margin-top: 30px; /* keep spacing from content above */\n}\n\n.reset-all {\n  background: #fff;\n  border: 1px solid #e0e0e0;\n  padding: 8px;\n  gap: 4px;\n  border-radius: 4px;\n  cursor: pointer;\n  color: #0066cc;\n  font-size: 14;\n}\n\n.apply-btn {\n  background: #0066cc;\n  color: #fff;\n  border: none;\n  width: 57px;\n  height: 35px;\n  padding: 8px;\n  gap: 4px;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n.side-modal-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.4);\n  display: flex;\n  justify-content: flex-end;\n  z-index: 1000;\n}\n\n.side-modal {\n  background: #fff;\n  width: 640px;\n  /* height: 849px; */\n  padding: 30px;\n  box-shadow: -2px 0 8px rgba(0, 0, 0, 0.1);\n  overflow-y: auto;\n  border-radius: 8px 0 0 8px;\n  margin-top: 80px;\n  display: flex;\n  flex-direction: column;\n  margin-right: 8px;\n}\n\n.side-modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  border-bottom: 1px solid #e6e6e6;\n  padding-bottom: 12px;\n  margin-bottom: 10px;\n}\n\n.app-title {\n  font-size: 18px;\n  font-weight: 600;\n  color: #0066cc;\n  margin: 0;\n}\n\n.app-subtitle {\n  font-size: 14px;\n  color: #999;\n  margin: 0;\n}\n\n.modal-close {\n  background: none;\n  border: none;\n  cursor: pointer;\n}\n\n.info-row {\n  display: grid;\n  grid-template-columns: 150px 1fr; /* first column fixed width for labels, second column fills remaining space */\n  column-gap: 40px; /* horizontal gap between label and value */\n  margin: 16px 0;\n  font-size: 14px;\n}\n\n.info-row .label {\n  color: #5b5b5b;\n  font-weight: 400;\n  justify-self: start;\n  width: 184px;\n}\n.info-row span:nth-child(2) {\n  justify-self: start;\n}\n\n.tier-pill {\n  padding: 4px 10px;\n  background: #f4f4f4;\n  border-radius: 16px;\n  font-size: 12px;\n}\n\n.description-box {\n  background: #f2f7fe;\n  padding: 12px;\n  border-radius: 6px;\n  margin: 20px 0;\n}\n\n.description-box h4 {\n  margin: 0 0 6px;\n  font-size: 14px;\n  color: #5b5b5b;\n  font-weight: 400;\n}\n\n.section-title {\n  font-size: 15px;\n  font-weight: 500;\n  margin: 20px 0 10px;\n  border-bottom: 1px solid #ccc;\n  padding-bottom: 4px;\n}\n\n.action-modal-backdrop {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100vw;\n  height: 100vh;\n  background: rgba(0, 0, 0, 0.3);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 999;\n}\n\n.action-modal {\n  width: 580px;\n  border: 1px solid #ddd;\n  border-radius: 8px;\n  background: #fff;\n  padding: 24px;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  text-align: center;\n}\n\n.action-modal-title {\n  font-size: 16px;\n  margin: 0;\n}\n\n.action-modal-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n  border-top: 1px solid #0047b3;\n  padding-top: 16px;\n}\n\n.btn-cancel {\n  background: transparent;\n  border: none;\n  padding: 6px 16px;\n  border-radius: 4px;\n  cursor: pointer;\n  color: #2563eb;\n  box-shadow: 0px 0.5px 2.5px 0px #0000004d;\n}\n\n.btn-confirm {\n  background: transparent;\n  border: none;\n  padding: 6px 16px;\n  border-radius: 4px;\n  cursor: pointer;\n  box-shadow: 0px 0.5px 2.5px 0px #0000004d;\n}\n\n.btn-confirm.accept {\n  color: #10b981;\n}\n\n.btn-confirm.reject {\n  color: #ef4444;\n}\n\n.action-modal-icon {\n  width: 87px;\n  height: 88px;\n  margin: 0 auto;\n}\n\n.action-modal-title.accept {\n  color: #10b981; /* green */\n}\n\n.action-modal-title.reject {\n  color: #ef4444; /* red */\n}\n\n.action-modal-comment {\n  width: 100%;\n  min-height: 80px;\n  border: 1px solid #ddd; /* default border */\n  border-radius: 6px;\n  padding: 8px;\n  resize: none;\n  outline: none; /* remove default browser outline */\n  transition: border-color 0.2s; /* smooth transition */\n  color: #808080;\n}\n\n/* Change border color on focus */\n.action-modal-comment:focus {\n  border-color: #2563eb; /* blue border on focus */\n  box-shadow: 0 0 0 2px rgba(37, 99, 235, 0.2); /* optional subtle glow */\n}\n\n/* ===== Responsive Breakpoints ===== */\n\n/* Medium devices (tablets) */\n@media (max-width: 1280px) {\n  .apps-col {\n    font-size: 10px;\n  }\n}\n\n@media (max-width: 992px) {\n  .apps-table-container {\n    overflow-x: auto;\n  }\n  .apps-table-row,\n  .body-row {\n    grid-template-columns: 50px 1fr 1.5fr 1.5fr 1fr 1fr 1fr 1fr; /* fewer columns visible */\n  }\n  /* .apps-col:nth-child(9) { display: none; } hide less-important last col */\n  .apps-table-header {\n    overflow-x: auto;\n    font-size: 0.6875rem;\n    font-weight: bold;\n  }\n}\n\n/* Small devices (mobile) */\n@media (max-width: 768px) {\n  .apps-table-header,\n  .apps-table-body {\n    min-width: 650px; /* make table scroll horizontally */\n  }\n\n  .apps-table-row,\n  .body-row {\n    grid-template-columns: 50px 1.2fr 1.8fr 1.8fr 1fr; /* show first few key columns */\n  }\n\n  /* Hide secondary columns on mobile */\n  .apps-col:nth-child(n + 6) {\n    display: none;\n  }\n\n  /* Adjust search/filter bar */\n  .app-toolbar {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n\n  .toolbar-right {\n    width: 100%;\n    justify-content: space-between;\n  }\n\n  .search-box {\n    width: 100%;\n  }\n}\n\n/* Extra small devices */\n@media (max-width: 480px) {\n  .page-title {\n    font-size: 14px;\n  }\n\n  .onboard-app-btn {\n    min-width: 100px;\n    font-size: 12px;\n  }\n\n  .apps-col {\n    font-size: 13px;\n    padding: 10px 6px;\n  }\n\n  .apps-col_tier {\n    font-size: 12px;\n    padding: 10px 6px;\n  }\n}\n\n@media (max-width: 1536px) {\n  .filter-popup {\n    width: 540px;\n    padding: 10px;\n  }\n  .filter-header {\n    font-size: 15px;\n    padding-bottom: 5px;\n    margin-bottom: 10px;\n  }\n  .filter-footer {\n    padding-top: 0px;\n    border-top: 0px;\n    margin-top: 0px;\n  }\n  .filter-section {\n    margin-bottom: 10px;\n  }\n}\n\n.apps-table-header::-webkit-scrollbar {\n  width: 1px;\n  height: 3px;\n}\n\n.apps-table-header::-webkit-scrollbar-thumb {\n  background-color: rgba(0, 0, 0, 0.2);\n  border-radius: 3px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
